<template>
  <div>
    <b-modal
      size="md"
      no-close-on-backdrop
      hide-footer
      id="modalCreate"
      title="NOVO REGISTRO"
    >
      <CreateResidentMonitoredHealth
        v-on:success="paginate"
        :resident_id="resident_id"
      />
    </b-modal>

    <div class="row">
      <div
        class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12 pr-0 d-flex align-items-center"
      >
        <h1 class="title-pages">INTERCORRÊNCIAS</h1>
      </div>
      <div
        class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12 pl-0 text-right pl-0"
      >
        <v-btn @click="$bvModal.show('modalCreate')" class="btn-add m-1"
          ><i class="fas fa-plus mr-2 text-twenty"></i> ADICIONAR</v-btn
        >
      </div>
    </div>

    <b-overlay :show="loading" opacity="0.99">
      <div
        class="v-clean p-5 text-center"
        v-show="resident_monitored_health_problems.length == 0"
      >
        <h6 class="text-center upper-text worksansr">SEM RESULTADOS!</h6>
      </div>

      <v-data-table
        v-show="resident_monitored_health_problems.length > 0"
        :headers="headers"
        :items="resident_monitored_health_problems"
        :footer-props="{
          'items-per-page-options': [50, 75, 100],
          'items-per-page-text': 'Mostrar',
        }"
      >
        <template v-slot:[`item.type`]="{ item }">
          ({{ formatType(item.type) }})
        </template>

        <template v-slot:[`item.date`]="{ item }">
          {{ formatDate(item.date, false) }}
        </template>

        <template v-slot:[`item.created_at`]="{ item }">
          {{ formatDate(item.created_at) }}
        </template>

        <template v-slot:[`item.actions`]="{ item }">
          <confirmation-dialog
            x_small
            message-title="EXCLUIR?"
            message-body="Deseja realmente excluir?"
            open-class="btn-modern btn-modern-delete m-1"
            open-left-icon="fa-trash"
            open-text="EXCLUIR"
            @yes="handleDelete(item.id)"
          />
        </template>
      </v-data-table>
    </b-overlay>
  </div>
</template>

<script>
import api from "../../services/api";

import { formatDate } from "../../lib/format";

import CreateResidentMonitoredHealth from "./Create";

import ConfirmationDialog from "../Components/ConfirmationDialog";

export default {
  name: "ResidentMonitoredHealth",

  components: {
    CreateResidentMonitoredHealth,
    ConfirmationDialog,
  },

  props: {
    resident_id: [String, Number],
  },

  data() {
    return {
      headers: [
        { text: "CRIADO POR", value: "user_name", sortable: false },
        { text: "TIPO", value: "type", sortable: false },
        { text: "TEXTO", value: "text", sortable: false },
        { text: "DATA", value: "date", sortable: false },
        { text: "DATA CADASTRO", value: "created_at", sortable: false },
        { text: "", value: "actions", sortable: false },
      ],

      resident_monitored_health_problems: [],

      resident_monitored_health_problem: {},

      errors: [],

      loading: false,
    };
  },

  async created() {
    this.paginate();
  },

  methods: {
    formatDate,

    formatType(type) {
      const types = {
        QUEDA: "Queda",
        ACOMPANHADO_PROBLEMA_SAUDE: "Acompanhamento de problema de saúde",
        INTERNACAO: "Internação",
        INFECCAO: "Infecção",
      };
      return types[type] || type;
    },

    async paginate() {
      try {
        this.loading = true;

        let { resident_id } = this;

        let params = {
          resident_id,
          by_resident: "by_resident",
        };

        let response = await api.get(
          "/rest-home/resident/dashboard/monitored-health-problems",
          {
            params,
          }
        );

        let { data } = response.data;

        this.resident_monitored_health_problems = data;

        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },

    async handleDelete(id) {
      try {
        this.loadingDelete = true;

        await api.delete(
          "/rest-home/resident/dashboard/monitored-health-problems",
          { data: { id, resident_id: this.resident_id } }
        );

        this.paginate();

        this.loadingDelete = false;
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>